<header class="auth-header">
  <nav class="auth-header__nav">
    <a class="auth-header__brand" routerLink="/">
      <img
        src="assets/images/easyVTA_logo_for_whiteBG.png"
        alt="easyVTA"
      />
    </a>

    <button
      class="auth-header__toggler"
      type="button"
      [class.active]="isMenuOpen"
      (click)="toggleMenu()"
      aria-label="Toggle navigation"
    >
      <span class="toggler-icon"></span>
      <span class="toggler-icon"></span>
      <span class="toggler-icon"></span>
    </button>

    <div class="auth-header__links" [class.open]="isMenuOpen">
      <a
        class="auth-header__link"
        routerLink="/register"
        routerLinkActive="active"
      >Register</a>
      <a
        class="auth-header__link"
        routerLink="/login"
        routerLinkActive="active"
      >Login</a>
    </div>
  </nav>
</header>
